export const getBaseUrl = (config, defaultBaseUrl) => config.withAbsoluteLinks ? config.absoluteBaseUrl ? config.absoluteBaseUrl : defaultBaseUrl : "";
export const getLogoUrl = (config, baseUrl, defaultLogoUrl) => {
  if (config.withAbsoluteLinks) {
    return `${baseUrl}${defaultLogoUrl}`;
  }
  return defaultLogoUrl;
};